import { Arrival } from './components/Arrival/Arrival';
import { Departure } from './components/Departure/Departure';


const App = () => {
  return (
    <>
      <h1>Расписание</h1>
      <Departure />
      <hr style={{ border: '1px solid' }}></hr>
      <Arrival />
    </>
  );
}

export default App;
